import { render, staticRenderFns } from "./CommonLoopContainer.vue?vue&type=template&id=81be95b2&scoped=true"
import script from "./CommonLoopContainer.vue?vue&type=script&lang=js"
export * from "./CommonLoopContainer.vue?vue&type=script&lang=js"
import style0 from "./CommonLoopContainer.vue?vue&type=style&index=0&id=81be95b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81be95b2",
  null
  
)

export default component.exports